import { DataTable } from "../components/DataTable";
import { PipelineCards } from "../components/PipelineCards";

export function RfqsTab() {
  return (
    <div className="space-y-4">
      <PipelineCards />
      <p className="text-[11.5px] text-muted">
        On RFQs only the Vessel, Supplier, date range and search filters apply. Search matches the RFQ or a linked requisition number.
      </p>
      <DataTable table="rfqs" title="RFQs" lens="rfq" />
    </div>
  );
}
